var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-nav g-flex-box"},[_c('h1',{staticClass:"app-logo",on:{"click":_vm.clickToHome}}),_c('div',{staticClass:"app-menu-box g-flex-item-1"},[_c('app-menu',{attrs:{"menuList":_vm.menuList}})],1),_c('span',{staticClass:"language-btn"})])
}
var staticRenderFns = []

export { render, staticRenderFns }